import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobicred-version-two',
  templateUrl: './mobicred.component.html',
  styleUrls: ['./mobicred.component.scss']
})
export class MobicredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
